var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 17.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.702.012c2.39-.152,4.651,1.118,5.775,3.216.977,1.824.901,4.03-.048,5.842-.042.079-.203.288-.185.355l1.503,1.512c.128.03.25-.02.392-.015.343.011.745.164,1.012.378l3.49,3.49c1.208,1.681-.886,3.633-2.491,2.259-1.144-.98-2.167-2.291-3.301-3.303-.365-.436-.501-.921-.42-1.49l-1.426-1.417-.087.018c-3.25,2.61-8.124,1.242-9.545-2.664C-1.018,4.378,1.661.27,5.702.012ZM10.332,6.102c0-2.337-1.895-4.232-4.232-4.232S1.868,3.765,1.868,6.102s1.895,4.232,4.232,4.232,4.232-1.895,4.232-4.232Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarInspection);
export default __webpack_public_path__ + "static/media/Sidebar_Inspection.fc2704cd9e9cb125bf5b1f0c0d9247d2.svg";
export { ForwardRef as ReactComponent };